<template>
  <v-card class="text-xs-center" style="min-height:525px;">
    <v-toolbar dense flat color="white">
      <v-btn icon absolute @click="$router.go(-1)">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <h1>Select service</h1>
      <v-spacer />
    </v-toolbar>
    <v-container fluid grid-list-lg class="pt-0">
      <v-layout justify-center align-center wrap>
        <v-flex md5 sm8 xs12 v-if="Object.keys(permission.food).length > 0 ">
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="toServiceFood"
              @click="$store.commit('backOffice/showMenu','weserve')"
            >
              <v-layout class="mt-2">
                <v-flex xs4 class="py-0 pr-0">
                  <div class="d-flex flex-icon-btn">
                    <v-icon large color="black">fastfood</v-icon>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <div class="text-service2">Food delivery</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

        <v-flex md5 sm8 xs12 v-if="Object.keys(permission.store_and_product).length > 0 ">
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="toServiceStoreProduct"
              @click="$store.commit('backOffice/showMenu','storeandproduct')"
            >
              <v-layout class="mt-2">
                <v-flex xs4 class="py-0 pr-0">
                  <div class="d-flex flex-icon-btn">
                    <v-icon large color="black">store_mall_directory</v-icon>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <div class="text-service2">Store & Product</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

        <v-flex md5 sm8 xs12 v-if="Object.keys(permission.messenger).length > 0 ">
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="toServiceMess"
              @click="$store.commit('backOffice/showMenu','messenger')"
            >
              <v-layout class="mt-2">
                <v-flex xs4 class="py-0 pr-0">
                  <div class="d-flex flex-icon-btn">
                    <v-icon large color="black">archive</v-icon>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <div class="text-service2">Messenger</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

        <v-flex md5 sm8 xs12 v-if="Object.keys(permission.rider).length > 0 ">
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="toServiceRider"
              @click="$store.commit('backOffice/showMenu','rider')"
            >
              <v-layout class="mt-2">
                <v-flex xs4 class="py-0 pr-0">
                  <div class="d-flex flex-icon-btn">
                    <v-icon large color="black">directions_bike</v-icon>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <div class="text-service2">Rider</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

        <v-flex md5 sm8 xs12 v-if="Object.keys(permission.report).length > 0 ">
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="'/weserve_admin_login/control/' + $route.params.province + '/report/main_dashboard'"
              @click="$store.commit('backOffice/showMenu','report')"
            >
              <v-layout class="mt-2">
                <v-flex xs4 class="py-0 pr-0">
                  <div class="d-flex flex-icon-btn">
                    <v-icon large color="black">description</v-icon>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <div class="text-service2">Report</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>

        <v-flex md5 sm8 xs12 v-if="Object.keys(permission.app_setting).length > 0 ">
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              router-link
              :to="'/weserve_admin_login/control/' + $route.params.province + '/setapp/setpromotionbanner'"
              @click="$store.commit('backOffice/showMenu','setapp')"
            >
              <v-layout class="mt-2">
                <v-flex xs4 class="py-0 pr-0">
                  <div class="d-flex flex-icon-btn">
                    <v-icon large color="black">smartphone</v-icon>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <div class="text-service2">App setting</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    toServiceFood() {
      if (this.permission.food) {
        if (this.permission.food.promotion_list) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/food/promotion"
          );
        } else if (this.permission.food.package_list) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/food/packagelist"
          );
        } else if (this.permission.food.transfer_list) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/food/transfer"
          );
        } else {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/food/free/set_price_round"
          );
        }
      }
    },
    toServiceStoreProduct() {
      if (this.permission.store_and_product) {
        if (this.permission.store_and_product.store_list) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/storeandproduct/storemanage"
          );
        } else {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/storeandproduct/productapprove"
          );
        }
      }
    },
    toServiceRider() {
      if (this.permission.rider) {
        if (this.permission.rider.rider_list.rider_user) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/rider/riderinhouse"
          );
        } else if (this.permission.rider.rider_list.rider_approve) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/rider/riderapprove"
          );
        } else if (this.permission.rider.rider_money.rider_wallet) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/rider/wallet"
          );
        } else if (this.permission.rider.rider_money.rider_request) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/rider/request_cash"
          );
        } else if (this.permission.rider.rider_money.rider_withdraw) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/rider/withdraw_cash"
          );
        } else if (this.permission.rider.rider_money.rider_refill) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/rider/refill_credit"
          );
        } else {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/rider/setting_bank"
          );
        }
      }
    },
    toServiceMess() {
      if (this.permission.messenger) {
        if (this.permission.messenger.addon) {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/messenger/addon"
          );
        } else {
          return (
            "/weserve_admin_login/control/" +
            this.$route.params.province +
            "/messenger/vehicletype"
          );
        }
      }
    },
  },
  methods: {},
  mounted() {
    this.$store.commit("backOffice/showMenu", null);
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: true,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
    this.$store.commit("backOffice/showMenu", null);
  },
};
</script>

<style scoped>
/* .text-service {
  font-size: 16px;
} */
.text-service2 {
  font-size: 20px;
  margin-top: 5px;
  padding: 20px;
  /* text-align: left; */
}
.flex-icon-btn {
  background-color: #ffd600;
  height: 100%;
  border-radius: 3px 0px 0px 3px;
}
</style>
